// extracted by mini-css-extract-plugin
export var text = "_6d-0";